import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IFile } from '@model/file';

import { apiClient } from '@services/apiClient';

interface IResponse {
  images: Array<IFile>;
}

export const installationPointPhotosKey = (installationPointId?: string | number) => [
  'installationPointPhotos',
  installationPointId,
];

export const installationPointPhotosFn = (
  queryKey: ReturnType<typeof installationPointPhotosKey>,
  signal: AbortSignal | undefined,
) =>
  apiClient.get(`${APP_API_URL_V2}fsd/installation-point/get-installation-point-images`, {
    params: { installationPointId: queryKey[1] },
    signal,
  });

const installationPointPhotosSelect = ({ data }: AxiosResponse<IResponse>) => data?.images || [];

export const useInstallationPointPhotosQuery = ({
  installationPointId,
  enabled,
}: {
  installationPointId?: string | number;
  enabled: boolean;
}) => {
  return useQuery({
    queryKey: installationPointPhotosKey(installationPointId),
    queryFn: ({ queryKey, signal }) => installationPointPhotosFn(queryKey, signal),
    enabled,
    select: installationPointPhotosSelect,
  });
};
